<!-- 文章组件 -->
<template>
  <div class="article" :style="{width:width,margin:margin}">
    <div class="title">{{ title }}</div>
    <!-- TODO: 样式 -->
    <div class="sub-title">{{ subTitle }}</div>
    <div class="authors">{{ authors }}</div>
    <div class="authors">{{ secondAuthors }}</div>
    <div class="content" v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: 'Article',
  props: {
    title: String,
    subTitle: String,
    authors: String,
    secondAuthors: String,
    html: {
      type: String,
      required: true
    },
    width: String,
    margin: String
  }
}
</script>
<style lang="scss">
.article{
  .title {
    text-align: center;
    font-size: 24px;
    // padding: 0 10%;
    padding: 0 110px;
    margin-bottom: 15px;
  }
  .sub-title {
    text-align: center;
    color: #909399;
    font-size: 18px;
  }
  .authors {
    text-align: center;
    color: #aaa;
    margin-bottom: 15px;
  }
  .content {
    margin-top: 20px;
    color: #333;
    line-height: 32px;
    font-size: 18px;
    img {
      max-width: calc(100% - 110px);
      height: auto;
    }
  }
}
</style>